module.exports = __webpack_public_path__ + "img/ic-blokk.b334b12e.svg";